export default __webpack_public_path__ + "images/5c41cf03b4552e1ff8f444f53b0d78a9-Eventbrite_NYE_HomepageC_1919x543.webp";